import { EMAIL_UNIT_KEY } from '@/js/customProducts/emailKeys'
import type { BuyRequest, IRogue, Product } from '@/js/services/RogueTypes'

// Shared by the side cart, order history and the order-confirmation email so the three cannot drift. A corner unit is 43" by definition, so the catalog's "Corner" width is replaced rather than printed.
export function getMassStorageUnitDescription(attributes: Partial<Product['attributes']> | undefined): string {
  const height = attributes?.mass_height
  const width = attributes?.mass_width

  if (String(width ?? '').toLowerCase().includes('corner')) {
    return `${height} Height - 43" Width - Corner`
  }

  return `${height} Height - ${width} Width - Straight Rack`
}

// useUnitAccordions numbers MS/MMS units from the base unit, so metadata.unitNumber is already the customer-facing number; a line without one gets no header rather than a wrong one.
export function getMassStorageEmailUnitLabel(rogue: IRogue, unit: BuyRequest): string | undefined {
  const unitNumber = unit.metadata?.unitNumber

  if (typeof unitNumber !== 'number') return undefined

  // Walked through rogue.getProductById like getSimpleForBuyRequest does, minus its live-pinia dependency, so the checkout-time caller can use it too.
  let node: BuyRequest | undefined = unit
  while (node?.children?.length) {
    node = node.children[0]
  }

  return `Unit ${unitNumber} - ${getMassStorageUnitDescription(node ? rogue.getProductById(node.productId)?.attributes : undefined)}`
}

// The unit's first child is the row the side cart reads the unit's attributes from, so it carries the header; every other child stays a plain tile. Matched by value so a clone upstream in lib-payments cannot silently drop it.
export function getMassStorageEmailLayout(rogue: IRogue, unit: BuyRequest, child: BuyRequest): Record<string, string> | undefined {
  const first = unit.children?.[0]

  if (!first || first.productId !== child.productId || first.metadata?.bundleOptionId !== child.metadata?.bundleOptionId) return undefined

  const label = getMassStorageEmailUnitLabel(rogue, unit)

  return label ? { [EMAIL_UNIT_KEY]: label } : undefined
}
